import { render } from "./pencil.vue?vue&type=template&id=4d547b7d"
import script from "./pencil.vue?vue&type=script&lang=js"
export * from "./pencil.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__